import React, { useContext } from "react";
import moment from "moment";
import { useForm } from "react-hook-form";

import { lighten, makeStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Chip,
  Grid,
  Card,
  CardContent,
  Typography,
} from "@material-ui/core";

import { RecruitmentContext } from "../../../../context/states/recruitmentState";
import { AuthContext } from "../../../../context/states/authState";

const useStyles = makeStyles((theme) => ({
  status: {
    color: theme.palette.secondary.main,
    backgroundColor: lighten(theme.palette.secondary.light, 0.9),
  },
}));

export const AddNotes = React.memo((props) => {
  const classes = useStyles();

  const { open, handleClose, onSubmitHandler, data } = props;

  const { isRecruitmentNotes } = useContext(RecruitmentContext);
  const { currentUser, permissionKeys } = useContext(AuthContext);

  console.log(isRecruitmentNotes);

  const { register, handleSubmit, errors, formState, reset } = useForm({
    mode: "onChange",
  });

  const onSubmit = (formData) => {
    const { id, text, updatedBy } = formData;

    const note = {
      id,
      text: `Note: ${text}`, // keep same format if you want
      updatedBy,
    };

    onSubmitHandler(note);
    reset({ text: "" });
  };

  const canAddNote = permissionKeys.includes("edit-recruitment.notes.add");

  return (
    <>
      <form onSubmit={(e) => e.preventDefault()}>
        {/* Hidden Fields */}
        <input
          type="hidden"
          name="updatedBy"
          ref={register}
          defaultValue={currentUser.fullName}
        />

        <input type="hidden" name="id" ref={register} defaultValue={data._id} />

        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
          {/* HEADER */}
          <DialogTitle>
            <Grid container justify="space-between">
              <Grid item>Recruitment Notes</Grid>

              <Grid item>
                <Chip
                  color="primary"
                  size="small"
                  label={"Recruitment ID: " + data.recId}
                />
              </Grid>
            </Grid>
          </DialogTitle>

          {/* NOTES LIST */}
          <DialogContent>
            {isRecruitmentNotes?.map((d) => {
              const checkStatus = d.text.split(":");

              return (
                <Card
                  key={d._id}
                  style={{ marginBottom: "6px" }}
                  className={checkStatus[0] !== "Note" ? classes.status : ""}
                >
                  <CardContent>
                    <Typography variant="body2">
                      <strong>{checkStatus[0]}: </strong>
                      {d.text.replace(checkStatus[0] + ":", "")}
                    </Typography>

                    <Typography variant="subtitle2" color="textSecondary">
                      <span style={{ textTransform: "capitalize" }}>
                        {d.updatedBy}
                      </span>{" "}
                      |{" "}
                      {moment(d.updated).format(
                        "dddd, MMMM Do YYYY, h:mm:ss a",
                      )}
                    </Typography>
                  </CardContent>
                </Card>
              );
            })}
          </DialogContent>

          {/* INPUT */}
          <div style={{ padding: "8px" }}>
            <TextField
              label="Add Note"
              variant="outlined"
              multiline
              disabled={!canAddNote}
              maxRows={6}
              fullWidth
              name="text"
              inputRef={register({
                minLength: {
                  value: 4,
                  message: "Must have at least 4 characters",
                },
              })}
              error={!!errors.text}
              helperText={errors.text && errors.text.message}
            />
          </div>

          {/* ACTIONS */}
          <DialogActions>
            <Button onClick={handleClose}>Close</Button>

            {canAddNote && (
              <Button
                variant="contained"
                color="primary"
                disabled={
                  !canAddNote || !formState.isDirty || !formState.isValid
                }
                onClick={handleSubmit(onSubmit)}
              >
                Add Note
              </Button>
            )}
          </DialogActions>
        </Dialog>
      </form>
    </>
  );
});
